module.exports = __webpack_public_path__ + "img/aurora.8671c14c.svg";